import { render, staticRenderFns } from "./DiscountActivationForm.vue?vue&type=template&id=2784718b&"
import script from "./DiscountActivationForm.vue?vue&type=script&lang=js&"
export * from "./DiscountActivationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports